import { styled } from "styled-system/jsx";

export const Button = styled("button", {
	base: {
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		gap: "2",
		borderRadius: "md",
		fontWeight: "medium",
		// The control is sized by its padding, not by an inherited line box.
		lineHeight: "1",
		whiteSpace: "nowrap",
		// Every variant carries a border, so primary and secondary are the same height.
		borderWidth: "1px",
		borderStyle: "solid",
		cursor: "pointer",
		transition: "background 0.15s, border-color 0.15s",
		/**
		 * A finger's minimum target. Keyed on pointer capability rather than on
		 * width, so a tablet that clears every breakpoint still gets it — and a
		 * mouse-driven session at any width keeps the padding-derived height below.
		 * `min-height` rather than `height` so the `sm` size still differs in
		 * padding and font, and so a button that wraps to two lines still grows.
		 */
		"@media (pointer: coarse)": { minHeight: "44px" },
		_disabled: {
			opacity: 0.6,
			cursor: "not-allowed",
		},
	},
	variants: {
		variant: {
			primary: {
				background: "gray.900",
				borderColor: "gray.900",
				color: "white",
				"&:not(:disabled):hover": { background: "gray.700", borderColor: "gray.700" },
			},
			secondary: {
				background: "white",
				borderColor: "gray.300",
				color: "gray.900",
				"&:not(:disabled):hover": { background: "gray.50", borderColor: "gray.400" },
			},
			ghost: {
				background: "transparent",
				borderColor: "transparent",
				color: "gray.600",
				"&:not(:disabled):hover": { background: "gray.50" },
			},
			/** Irreversible actions only — the colour is the warning. */
			danger: {
				background: "red.600",
				borderColor: "red.600",
				color: "white",
				"&:not(:disabled):hover": { background: "red.700", borderColor: "red.700" },
			},
		},
		size: {
			md: { paddingX: "4", paddingY: "2", fontSize: "sm" },
			sm: { paddingX: "3", paddingY: "1.5", fontSize: "sm" },
		},
	},
	defaultVariants: {
		variant: "primary",
		size: "md",
	},
});
